import React from 'react';
import ScanQrPage from '../pages/ScanQrPage';

const ScanQrRoute: React.FC = () => <ScanQrPage />;

export default ScanQrRoute;
